/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'fabric.linkPicker.button.cancel': 'Zrušit',
  'fabric.linkPicker.button.insert': 'Vložit',
  'fabric.linkPicker.button.save': 'Uložit',
  'fabric.linkPicker.clearLink': 'Vymazat',
  'fabric.linkPicker.clearLinkText': 'Vymazat text',
  'fabric.linkPicker.hyperlink.searchLinkResults': '{count, plural, =0 {nebyly nalezeny žádné výsledky} one {{count,number} nalezený výsledek} few {{count,number} nalezené výsledky} many {{count,number} nalezeného výsledku} other {{count,number} nalezených výsledků}}',
  'fabric.linkPicker.linkAriaLabel': 'Zadejte nebo vložte odkaz do pole.',
  'fabric.linkPicker.linkHelperTextAriaLabel': 'Text nápovědy k zobrazení pro odkaz',
  'fabric.linkPicker.linkHelperTextLabel': 'Dejte tomuto odkazu název nebo popis.',
  'fabric.linkPicker.linkInvalid': 'Zadejte platnou adresu URL.',
  'fabric.linkPicker.linkLabel': 'Odkaz',
  'fabric.linkPicker.linkPlaceholder': 'Vložte odkaz.',
  'fabric.linkPicker.linkTextAriaLabel': 'Text k zobrazení pro odkaz',
  'fabric.linkPicker.linkTextLabel': 'Zobrazený text (volitelné)',
  'fabric.linkPicker.linkTextPlaceholder': 'Text k zobrazení',
  'fabric.linkPicker.listTitle.recentlyViewed': 'Nedávno zobrazeno',
  'fabric.linkPicker.listTitle.results': 'Výsledky',
  'fabric.linkPicker.search.error.description': 'Obnovte stránku nebo, pokud problém přetrvává, kontaktujte <a>podporu Atlassian</a>.',
  'fabric.linkPicker.search.error.heading': 'Při načítání dat se vyskytly problémy.',
  'fabric.linkPicker.search.error.retry': 'Obnovit',
  'fabric.linkPicker.search.linkAriaLabel': 'Níže se objeví návrhy na základě vámi napsaného textu v poli.',
  'fabric.linkPicker.search.linkLabel': 'Vyhledejte nebo vložte odkaz.',
  'fabric.linkPicker.search.linkPlaceholder': 'Vyhledejte nedávné odkazy nebo vložte nový.',
  'fabric.linkPicker.search.noResults.description': 'Zkuste to znovu s jiným termínem.',
  'fabric.linkPicker.search.noResults.heading': 'Vašemu vyhledávání neodpovídají žádné výsledky.',
  'fabric.linkPicker.status.submitting': 'Odesílání',
  'fabric.linkPicker.time.message.updated': 'Aktualizováno: {time}',
  'fabric.linkPicker.time.message.viewed': 'Zobrazeno: {time}',
  'fabric.linkPicker.unhandledError.description': 'Zkuste stránku načíst znovu.',
  'fabric.linkPicker.unhandledError.heading': 'Něco se pokazilo'
};